import React, { useEffect, useRef, useState } from "react";
import "./OutOfHomeWhy.css";
import { useTranslation } from "react-i18next";

const OutOfHomeWhy = ({ openModal }) => {
  const { t } = useTranslation();
  const cards = t("outOfHomePage.why.cards", { returnObjects: true });

  // Each card settles into place as it individually scrolls into
  // view, and reverts when it scrolls back out - always active,
  // re-triggers every time you scroll up or down past it (Pattison-
  // style scroll reveal, but repeatable rather than a one-shot).
  const cardRefs = useRef([]);
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const nodes = cardRefs.current.filter(Boolean);
    if (nodes.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const idx = Number(entry.target.dataset.index);
          if (entry.isIntersecting) {
            // Double rAF: guarantee the "hidden" state actually
            // paints before flipping to visible, otherwise a card
            // already in view on load can jump straight to its
            // final state with no visible motion.
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                setVisible((prev) => (prev.includes(idx) ? prev : [...prev, idx]));
              });
            });
          } else {
            setVisible((prev) => prev.filter((i) => i !== idx));
          }
        });
      },
      { threshold: 0.25 }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="oohs-section oohs-section--spacious">
      <div className="oohs-section-inner">
        <h2 className="oohs-title">{t("outOfHomePage.why.title")}</h2>

        <div className="ooh-why-grid">
          {cards.map((card, index) => (
            <div
              key={index}
              ref={(el) => (cardRefs.current[index] = el)}
              data-index={index}
              className={`oohs-card ooh-why-reveal ${
                visible.includes(index) ? "is-visible" : ""
              }`}
            >
              <div className="ooh-why-index oohs-accent-text">
                0{index + 1}
              </div>
              <h3 className="ooh-why-card-title">{card.title}</h3>
              <p className="ooh-why-card-text">{card.text}</p>
            </div>
          ))}
        </div>

        <button type="button" className="oohs-cta-btn" onClick={openModal}>
          {t("outOfHomePage.hero.button")}
        </button>
      </div>
    </div>
  );
};

export default OutOfHomeWhy;
